
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/impact-analysis-binary/create",
      function () {
        return require("private-next-pages/impact-analysis-binary/create.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/impact-analysis-binary/create"])
      });
    }
  